<template>
  <LocationCell
    :country="countryName"
    :country-code="countryCode"
    :detail="column.company.region?.name ?? null"
    :data-test="`client-location-${rowIndex}`"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import LocationCell from '@/components/LocationCell.vue'

const ClientLocationColumn = graphql(`
  fragment ClientLocationColumn on CompanySupplier {
    id
    company {
      id
      market
      region {
        id
        name
      }
      address {
        country {
          isoCode
          name
        }
      }
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof ClientLocationColumn>
  rowIndex?: number
}>()

const column = computed(() => useFragment(ClientLocationColumn, props.row))
const rowIndex = computed(() => props.rowIndex ?? 0)

// The registered address may be missing; the market is always set and doubles as the country.
const countryCode = computed(
  () => column.value.company.address?.country?.isoCode ?? column.value.company.market,
)
const countryName = computed(() => column.value.company.address?.country?.name ?? countryCode.value)
</script>
